import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { Button } from "components/Button";
import { List } from "components/List/List";

export const LearnMore = () => {
  const config = [
    {
      title: "Sužinokite",
      subTitle: "Kaip pagerinti savo įmonės finansinę sveikatą:",
      list: [
        "Atsisiųskite išsamią savo įmonės kreditingumo ataskaitą.",
        "Stebėkite savo ir kitų įmonių bankroto reitingo ir svarbių rodiklių pasikeitimus.",
        "Gaukite pranešimus apie jums svarbius pokyčius.",
      ],
    },
    {
      title: "Išbandykite",
      subTitle: "Finpass ankstyvojo perspėjimo sistemą",
      list: [
        "Kiekvienas prisijungęs ir patvirtinęs savo tapatybę gauna 2 nemokamas kreditingumo ataskaitas arba 2 įmonių stebėjimo paslaugą net 6 mėnesius.",
        "Įmonės vadovai gali stebėti savo įmones ir gauti jų kreditingumo ataskaitą visiškai nemokamai.",
        <span>
          Papildomos įmonės stebėjimas (6 mėn.) ar kreditingumo ataskaita kainuoja vos{" "}
          <Typography component="span" color="primary">
            6 Eur
          </Typography>{" "}
          be PVM.
        </span>,
      ],
    },
  ];

  return (
    <>
      <Stack
        direction={{ sm: "column", md: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "center", md: "initial" }}
        spacing={4}
      >
        {config.map(({ title, subTitle, list }) => (
          <Stack key={title}>
            <Typography variant="h2" color="primary">
              {title}
            </Typography>
            {subTitle && <Typography color="textGrey.main">{subTitle}</Typography>}
            <Box
              sx={{
                maxWidth: "28rem",
              }}
            >
              <List list={list} />
            </Box>
          </Stack>
        ))}
      </Stack>

      <Box textAlign="center" mt="4rem">
        <a href="https://finpass.eu/home?ref=swedbank" target="_blank" rel="noreferrer">
          <Button>Užsisakykite kreditingumo ataskaitas</Button>
        </a>
      </Box>
    </>
  );
};
